export default "__VITE_ASSET__CKIp9b3z__"